import { Link } from "react-router-dom";

const articleCards = [
  {
    slug: "product-comparison-mastery",
    title: "Product Comparison Mastery: Evaluate Like a Pro",
    desc: "Master the four-pillar comparison system that transforms how you evaluate products — price, community rating, availability, and source credibility — for consistently smarter purchases.",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20workspace%20with%20dual%20monitors%20displaying%20colorful%20data%20charts%20and%20product%20comparison%20grids%2C%20warm%20desk%20lamp%20lighting%2C%20coffee%20mug%20and%20notebook%20alongside%2C%20modern%20home%20office%20with%20plants%2C%20data-driven%20decision%20making%20concept%2C%20clean%20organized%20desk%20aesthetic&width=600&height=450&seq=article-card-comparison&orientation=landscape",
  },
  {
    slug: "trend-spotting-2026",
    title: "Trend Spotting 2026: What's Actually Hot",
    desc: "Go beyond the hype with data-backed trend analysis from the pandabuyspreadsheet. See which categories are surging and which products real shoppers are buying right now.",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20moodboard%20wall%20with%20magazine%20cutouts%20and%20fabric%20swatches%20pinned%20on%20cork%20board%2C%20colorful%20trend%20forecast%20palette%20cards%2C%20designer%20studio%20setting%2C%20creative%20and%20energetic%20atmosphere%2C%20pantone%20color%20swatches%20scattered%2C%20natural%20window%20light%2C%20fashion%20forecasting%20concept&width=600&height=450&seq=article-card-trends&orientation=landscape",
  },
  {
    slug: "save-money-shopping",
    title: "Save Money on Every Purchase: Proven Strategies",
    desc: "Concrete techniques that cut monthly spending by 20-40% using price tracking, cross-category bundles, and the community rating sweet spot method built into the spreadsheet.",
    imageUrl: "https://readdy.ai/api/search-image?query=Glass%20jar%20filled%20with%20rolled%20dollar%20bills%20and%20coins%20surrounded%20by%20shopping%20receipts%20and%20a%20calculator%20on%20wooden%20table%2C%20warm%20sunset%20light%20streaming%20through%20curtains%2C%20personal%20finance%20and%20savings%20concept%2C%20cozy%20home%20setting&width=600&height=450&seq=article-card-savemoney&orientation=landscape",
  },
  {
    slug: "seasonal-shopping-guide",
    title: "The Seasonal Shopping Calendar: Buy at the Right Time",
    desc: "Every category has a discount cycle. Learn exactly when shoes, hoodies, perfumes, and accessories hit their lowest prices so you never overpay for anything again.",
    imageUrl: "https://readdy.ai/api/search-image?query=Four%20season%20split%20composition%20showing%20spring%20floral%20dress%20summer%20sandals%20autumn%20scarf%20winter%20coat%2C%20circular%20calendar%20design%2C%20creative%20conceptual%20photography%2C%20soft%20natural%20lighting%20on%20light%20wood%20surface%2C%20seasonal%20wardrobe%20planning%20aesthetic&width=600&height=450&seq=article-card-seasonal&orientation=landscape",
  },
  {
    slug: "finding-hidden-gems",
    title: "Finding Hidden Gems Others Are Missing",
    desc: "Discover the high-rating low-volume pattern, regional exclusives, and new arrival strategies that help you find exceptional products before they blow up and prices climb.",
    imageUrl: "https://readdy.ai/api/search-image?query=Antique%20wooden%20treasure%20chest%20open%20revealing%20glowing%20golden%20light%20spilling%20out%2C%20surrounded%20by%20elegant%20fashion%20items%20like%20silk%20scarves%20and%20vintage%20watches%20on%20dark%20velvet%2C%20mysterious%20and%20magical%20atmosphere%2C%20discovery%20and%20hidden%20treasure%20concept&width=600&height=450&seq=article-card-gems&orientation=landscape",
  },
  {
    slug: "shopping-mistakes-avoid",
    title: "10 Shopping Mistakes That Drain Your Budget",
    desc: "From urgency bias to sunk cost fallacy — learn to recognize and sidestep the psychological traps and technical errors that cost online shoppers hundreds every month.",
    imageUrl: "https://readdy.ai/api/search-image?query=Shopping%20cart%20overflowing%20with%20random%20items%20and%20red%20warning%20signs%2C%20chaotic%20and%20humorous%20composition%2C%20person%20holding%20head%20in%20hands%20in%20background%20blur%2C%20bright%20colorful%20products%20spilling%20out%2C%20regret%20and%20overspending%20concept%2C%20editorial%20photography%20with%20satirical%20edge&width=600&height=450&seq=article-card-mistakes&orientation=landscape",
  },
  {
    slug: "category-deep-dive-shoes",
    title: "Category Deep Dive: Mastering the Shoes Sheet",
    desc: "An exhaustive walkthrough of sneaker tiers, boot seasonality, dress shoe quality signals, and how professional buyers read the shoes spreadsheet for maximum value extraction.",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20shoe%20collection%20displayed%20on%20floating%20shelves%20against%20exposed%20brick%20wall%2C%20sneakers%20and%20loafers%20and%20boots%20neatly%20arranged%20by%20color%20gradient%2C%20sneakerhead%20closet%20aesthetic%2C%20warm%20track%20lighting%2C%20collector%20display&width=600&height=450&seq=article-card-shoes&orientation=landscape",
  },
  {
    slug: "category-deep-dive-apparel",
    title: "Category Deep Dive: Apparel & Accessories",
    desc: "Build a cohesive wardrobe using cross-category spreadsheet strategy. Learn the capsule wardrobe approach that cuts spending by 25% while doubling outfit combinations.",
    imageUrl: "https://readdy.ai/api/search-image?query=Walk-in%20closet%20with%20color-coordinated%20clothing%20on%20wooden%20hangers%2C%20organized%20by%20rainbow%20spectrum%2C%20luxury%20dressing%20room%20with%20chandelier%20lighting%2C%20mirrored%20wall%2C%20boutique%20hotel%20aesthetic%2C%20aspirational%20organization%20lifestyle&width=600&height=450&seq=article-card-apparel&orientation=landscape",
  },
  {
    slug: "beginner-to-expert",
    title: "30-Day Spreadsheet Transformation: Beginner to Expert",
    desc: "A day-by-day roadmap from spreadsheet novice to confident power user. Each day adds a new skill — by day 30, reading the pandabuyspreadsheet will feel as natural as checking email.",
    imageUrl: "https://readdy.ai/api/search-image?query=Wall%20calendar%20with%20colorful%20sticky%20notes%20and%20checkmarks%20marking%20progress%2C%20surrounded%20by%20stylish%20products%20and%20shopping%20bags%20on%20a%20clean%20desk%2C%20goal%20tracking%20and%20achievement%20concept%2C%20morning%20sunlight%2C%20organized%20and%20motivated%20atmosphere&width=600&height=450&seq=article-card-journey&orientation=landscape",
  },
];

export default function ArticleCenter() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-14">
          <div className="lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight">
              PandaBuy Sheet
              <br />
              Buying Guides
            </h2>
          </div>
          <div className="lg:w-1/2 lg:pt-3">
            <p className="text-base text-foreground-500 leading-relaxed">
              Dive into our in-depth buying guides to master the pandabuyspreadsheet system.
              Learn how to spot trends, compare prices like a pro, and build your own curated
              shopping lists for maximum savings.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articleCards.map((card) => (
            <Link
              key={card.slug}
              to={`/guides/${card.slug}`}
              className="group bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 flex-1">
                  {card.desc}
                </p>
                <span className="text-sm text-primary-600 font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all mt-auto">
                  Read Article
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-secondary-500 text-background-50 text-base font-medium hover:bg-secondary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View All Spreadsheets
            <i className="ri-external-link-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}